export default __webpack_public_path__ + "static/media/FP_Logo_White.ece0182f.svg";